module.exports = __webpack_public_path__ + "img/angle_255.3322b707.jpg";